import { render, staticRenderFns } from "./confirmation_modal.vue?vue&type=template&id=63fbe8d8&scoped=true"
import script from "./confirmation_modal.vue?vue&type=script&lang=js"
export * from "./confirmation_modal.vue?vue&type=script&lang=js"
import style0 from "./confirmation_modal.vue?vue&type=style&index=0&id=63fbe8d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fbe8d8",
  null
  
)

export default component.exports